<template>
  <div class="wrapper">
    <div class="content">
      <h5>{{ title }}</h5>
      <p>
        {{ message }}
      </p>
      <b-button size="sm" variant="lisaweb" @click="action">OK</b-button>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped>
.wrapper {
  background-color: #fff;
  height: 100%;
  display: -webkit-flexbox;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-flex-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  justify-content: center;

  .content {
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    p {
      font-weight: bold;
      font-size: var(--font-size-xl);
      color: #009ADBFF;
      padding: 20px;

      button {
        margin-top: 20px;
      }
    }
  }
}
</style>
